import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from 'src/app/globals';
import { Approved } from '../modal/approved';

@Injectable({
    providedIn: 'root'
})

export class SendEmailService {
    constructor(private httpclient: HttpClient, private global: Globals) {
        console.log(this.global.loggedUser.token);
    }


    GetSendEmailList() {
        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + '/sendEmail/'+this.global.loggedUser.user.user_reg_id, { headers:header });

    }

    DeleteSendEmail(id){
        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.delete(this.global.G_apiUrl + '/sendEmail/'+id, { headers:header });
    }
    DeleteMultipleSendEmail(sendEmail){
        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.post(this.global.G_apiUrl + '/sendEmail/multipleDelete',sendEmail, { headers:header,responseType:'text' });
     
    }

    forwordMultiple(sendEmail) {
        debugger;
        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.post(this.global.G_apiUrl + "/sendEmail/Forword/"+ this.global.loggedUser.user.user_reg_id,sendEmail,{ headers:header, responseType: 'text'});
    }




}